export default __webpack_public_path__ + "static/media/cb-card.027bd296.jpeg";